import React, { Fragment, PropsWithChildren } from 'react';

import { FooterComponent } from '~/components/Footer/Footer.component';
import { HeaderComponent } from '~/components/Header/Header.component';
import { DataTransacton } from '~/entities/schemas/dataTransaction';

import styles from './Layout.module.scss';

interface LayoutComponentProps extends PropsWithChildren<any> {
  dataTransaction: DataTransacton | null;
  loadingDataTr: boolean;
}

export const LayoutComponent: React.FC<LayoutComponentProps> = ({ children, dataTransaction, loadingDataTr }) => (
  <Fragment>
    <HeaderComponent />
    <div className={styles.children}>{children}</div>
    <FooterComponent dataTransaction={dataTransaction} loadingDataTr={loadingDataTr} />
  </Fragment>
);
